import {
  FeatureFlagsContext,
  FeatureFlagsContextValues,
} from '@/providers/FeatureFlagsProvider';
import { useContext } from 'react';

export function useFeatureFlags() {
  return useContext<FeatureFlagsContextValues>(FeatureFlagsContext);
}
